import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import { VersionColumns } from 'components/common/enhanced/common-headers/version';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { logService } from 'services/api/LogService';

export const VersionDialog = ({
  open,
  onClose,
  versionId
}: {
  open: boolean;
  onClose: () => void;
  versionId: number;
}) => {
  const translationPrefix = 'pages.versions.detail';
  const [fields, setFields] = useState<any>([]);

  const { t } = useTranslation();

  useEffect(() => {
    logService.get(`/${versionId}/`).then((res) => {
      let newFields: any[] = [];
      let changes = {};
      if (res.changes) {
        if (typeof res.changes === 'string') {
          try {
            changes = JSON.parse(res.changes);
          } catch (e) {
            console.error('Errore nel parsing di res.changes:', e);
            changes = {};
          }
        } else {
          changes = res.changes;
        }
      }
      if (res.full_object) {
        newFields = Object.entries(res.full_object).map(([field, value], id) => {
          const fieldChange = changes[field];
          let newValue = value;
          let oldValue = value;
          if (fieldChange) {
            newValue = fieldChange[1];
            oldValue = fieldChange[0];
          }

          // Converti i valori complessi in stringa JSON per la visualizzazione
          const displayOldValue =
            typeof oldValue === 'object' && oldValue !== null ? JSON.stringify(oldValue) : oldValue;
          const displayNewValue =
            typeof newValue === 'object' && newValue !== null ? JSON.stringify(newValue) : newValue;

          field = t(`pages.versions.entities.${res.model_name}.${field}`);

          return {
            id,
            field,
            oldValue: displayOldValue,
            newValue: displayNewValue,
            edited: !!fieldChange
          };
        });
      }
      setFields(newFields);
    });
  }, []);

  const columns: GridColDef[] = VersionColumns();
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
      <DialogTitle>{t(`${translationPrefix}.title`) + ` ${versionId}`}</DialogTitle>
      <DialogContent sx={{ height: '70vh', minHeight: 360 }}>
        <DataGridPremium
          rows={fields}
          columns={columns}
          disableSelectionOnClick
          getRowClassName={(params) => (params.row.edited ? 'mui-edited' : '')}
          sx={{
            height: '100%',
            '& .mui-edited': {
              backgroundColor: '#fff3cd'
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('global.cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default VersionDialog;
